export default Object.freeze({
  VOICE: 'call_type_voice',
  SHORT_VOICE: 'call_type_short_voice',
  GONG: 'call_type_gong'
});